import { render, staticRenderFns } from "./trah.vue?vue&type=template&id=5015a127&"
import script from "./trah.vue?vue&type=script&lang=js&"
export * from "./trah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports